import React from 'react';

import Button from 'CommonComponents/Button';

/**
 * Picker footer (IB-641): Cancel discards the draft, Apply(N) commits it.
 */
export default function PickerFooter({ selectedCount, onApply, onCancel }) {
    return (
        <div className="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-pt-3 tw-mt-1 tw-border-t tw-border-grey">
            <Button variant="secondary" small onClick={onCancel}>
                {$t('Cancel')}
            </Button>
            <Button variant="primary" small onClick={onApply}>
                {$t('Apply ({{count}})', { count: selectedCount })}
            </Button>
        </div>
    );
}
